import type {
  GetAnalyticsCallDisconnectedByQuery,
  GetAnalyticsCallDisconnectedByQueryVariables,
} from "@/graphql/generated/graphql";
import { GetAnalyticsCallDisconnectedBy } from "@/graphql/queries/GetAnalyticsCallDisconnectedBy";
import { useQueryWrapper } from "../useQueryWrapper/useQueryWrapper";
import type { UseAnalyticsCallDisconnectedByReturn } from "./useAnalyticsCallDisconnectedBy.decl";

export function useAnalyticsCallDisconnectedBy(
  callId: string,
  createdAt: string
): UseAnalyticsCallDisconnectedByReturn {
  // Calculate date range from call creation date
  const callDate = new Date(createdAt);
  const fromDate = callDate.toISOString().split("T")[0]; // YYYY-MM-DD
  const toDate = fromDate; // Same day

  const { data, loading, error } = useQueryWrapper<
    GetAnalyticsCallDisconnectedByQuery,
    GetAnalyticsCallDisconnectedByQueryVariables
  >(GetAnalyticsCallDisconnectedBy, {
    variables: {
      input: {
        filter: {
          callIDs: [callId],
          dateFilter: {
            absoluteRange: {
              fromDate,
              toDate,
            },
          },
          timezone: "UTC",
        },
      },
    },
    skip: !callId || !createdAt,
  });

  const disconnectedBy =
    data?.analyticsCallsHistory?.__typename === "AnalyticsCallsHistory"
      ? (data.analyticsCallsHistory.items[0]?.disconnectedBy ?? undefined)
      : undefined;

  return {
    disconnectedBy,
    loading,
    error,
  };
}
